我<template>
  <div class="datum">
    <Personal-center-head>
      <div>我的资料</div>
      <template slot="revert">
        <div class="revert">返回</div>
      </template>
    </Personal-center-head>
    <!-- 用户身份 1项目申报人 2专家 3学会 4基金会 5医药仪器企业 6期刊厂商 7媒体公司 8其他 10销售 -->
    <xmsbr v-if="userTypeId==1 || userTypeId==8" />
    <zj v-if="userTypeId==2" />
    <essential-info v-if="userTypeId==3 || userTypeId==4" />
    <companies v-if="userTypeId==5" />
    <qk v-if="userTypeId==6" />
    <mt v-if="userTypeId==7" />
    <zxf v-if="userTypeId==9" />
  </div>
</template> 
     
<script> 
import PersonalCenterHead from '../../../components/PersonalCenterHead/index.vue'
import xmsbr from './xmsbr.vue'//项目申报人、其他
import zj from './zj.vue' //专家
import essentialInfo from './essentialInfo.vue'//学会、基金会
import companies from './companies.vue' //企业
import qk from './qk.vue' //期刊
import mt from './mt.vue' //媒体
import zxf from './zxf.vue';//执行方 
export default {
  name: 'datum',
  components: {
    PersonalCenterHead,
    xmsbr,
    zj,
    essentialInfo,
    companies,
    qk,
    mt,
    zxf
  },
  data () {
    return {
      userTypeId: 0
    }
  },
  created () {
    //this.userTypeId = JSON.parse(localStorage.getItem("userinfo")).userTypeId
    this.getMe()
  }, methods: {
    //获取个人信息
    async getMe () {
      const { data: data } = await this.$http.post('me')
      this.userTypeId = data.data.userTypeId
      localStorage.setItem("userinfo", JSON.stringify(data.data))
    },
  }
}

</script>
<style lang="less" scoped>
// .datum {
//   // padding: 50px 0px;
// }
</style> 